import { useMutation } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useSelectPhotoModal() {
  const { makeAuthedRequest } = Auth.useContainer();

  const uploadImage = useMutation(({ body }) => {
    return makeAuthedRequest(`image`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...body,
      }),
    }).then(async (res) => {
      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return {}; // fallback if no JSON
        }
      } else {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });

  return {
    uploadImage: uploadImage.mutate,
    isLoading: uploadImage.isLoading,
  };
}
